<template>
  <div>
    <div
      class="cfs-finder"
      v-for="(item, index) in cards.length"
      :key="index"
    >
      <div class="cfs-finder_cards">
        <div class="cfs-finder_cards-title">
          <b-row>
            <b-col cols="12">
              <Select2 placeholder="Country" v-model="country_selected" :options="countries"/>
            </b-col>
          </b-row>
        </div>
        <div class="cfs-finder_cards-blog-card">
          <div class="cfs-finder_cards-blog-card-text">
            <div>
              
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormInput,BFormGroup, BInputGroup,BInputGroupAppend,BRow, BCol,BCard,BCardText} from "bootstrap-vue";
import Select2 from 'v-select2-component';
import useJwt from "@/auth/jwt/useJwt";

export default {
  props: ["cards"],
  components: { BFormInput,BFormGroup, BInputGroup,BInputGroupAppend,BRow, BCol,Select2,BCard,BCardText},
  data() {
    return {
      country_selected: null,
      countries: [],
    }
  },
  mounted(){
    // TODO
    // useJwt.get('masterDataNologin?objectType=Country', {})
    // .then(response =>{
    //   this.countries = response.data.result;
    // })
  }
};
</script>
<style>
.cfs-finder .select2-selection--single{
    border: 1px solid #2B938C;
    border-radius: 1.5rem;
}
.cfs-finder .select2-selection--single:before {
  content: "";
  position: absolute;
  right: 20px;
  top: 0;
  bottom: 0;
  width: 40px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCA0NCAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMwLjc4ODggMjMuNTc3NkMzNS42NDI3IDIzLjU3NzYgMzkuNTc3NiAxOS42NDI3IDM5LjU3NzYgMTQuNzg4OEMzOS41Nzc2IDkuOTM0ODggMzUuNjQyNyA2IDMwLjc4ODggNkMyNS45MzQ5IDYgMjIgOS45MzQ4OCAyMiAxNC43ODg4QzIyIDE5LjY0MjcgMjUuOTM0OSAyMy41Nzc2IDMwLjc4ODggMjMuNTc3NloiIHN0cm9rZT0iIzJCOTM4QyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNDIuNDM0IDI2LjQzNDJMMzcuNjU1MSAyMS42NTUzIiBzdHJva2U9IiMyQjkzOEMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGxpbmUgeDE9IjAuNSIgeTE9IjIuMTg1NTdlLTA4IiB4Mj0iMC40OTk5OTkiIHkyPSIzMiIgc3Ryb2tlPSIjMkI5MzhDIi8+Cjwvc3ZnPgo=") center / contain no-repeat;
}
.cfs-finder .select2-selection__arrow{
  background: none;
  display: none !important;
}
</style>
<style lang="scss" scoped>
.cfs-finder {
  position: relative;
  background: -webkit-linear-gradient(top, #fff 50%, var(--bg-color-2) 50%);
  min-height: 600px;
  @media (min-width: 900px) {
    &:nth-child(1) {
      &::after {
        content: "";
        position: absolute;
        top: 36%;
        transform: translate(0, -50%);
        right: -110px;
        background-image: url("../../../../../assets/images/core-service/core-top.svg");
        background-repeat: no-repeat;
        background-size: 280px 280px;
        display: inline-block;
        width: 280px;
        height: 280px;
      }
      &::before {
        content: "";
        position: absolute;
        bottom: 110px;
        left: -120px;
        background-image: url("../../../../../assets/images/core-service/core-bottom.svg");
        background-repeat: no-repeat;
        background-size: 260px 260px;
        display: inline-block;
        width: 260px;
        height: 260px;
      }
    }
  }
  @media (min-width: 320px) {
    padding: 10px;
  }
  @media (min-width: 900px) {
    padding: 40px 70px;
  }
  @media (min-width: 1024px) {
    padding: 40px 250px;
  }
  @media (min-width: 1900px) {
    padding: 100px 470px;
  }

  &_cards {
    padding-left: 0;
    &-title {
      color: var(--text-normal-color);
      font-style: var(--normal-font-size);
      font-weight: 400;
      margin-bottom: 80px;
    }
    &-blog-card {
      display: flex;
      align-items: center;
      gap: 50px;
      flex-direction: column;
      @media (min-width: 900px) {
        flex-direction: row;
      }

      &-text {
        order: 2;
        flex: 0 0 50%;
        padding: 30px;
        padding-top: 130px;
        display: flex;
        flex-direction: column;
        gap: 30px;
        &-title {
          color: var(--primary-color);
          font-style: var(--big-font-size);
          font-weight: 700;
        }
        &-description {
          color: var(--text-normal-color);
          font-style: var(--normal-font-size);
          font-weight: 400;
        }
      }
      &-meta {
        flex: 0 0 50%;
        order: 1;
        &-photo {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>